import React from 'react'
import Navbar from '../HomePage/Navbar'
import Footer from '../HomePage/Footer'
import CommitteePage from './Committeepage'
function CommitteIndex() {
  return (
    <div style={{ fontFamily: 'Poppins, sans-serif' }}>
      <Navbar />
      <CommitteePage />
      <Footer />
    </div>
  )
}

export default CommitteIndex
